module.exports = __webpack_public_path__ + "img/节日派对-1@2x.e5f2fb22.png";